module.exports = __webpack_public_path__ + "img/job.a66550df.png";